import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { BaseApiService, ZohoApiService } from '../api';
import { CrmServiceInterface } from './interface';
import { ExportTypeEnum } from '../../enums';
import { AbstractCrmService } from './abstract-crm-service';
import { MappingFieldsRequestParamDto } from '../../dto';

@Injectable({
  providedIn: 'root',
})
export class ZohoService extends AbstractCrmService implements CrmServiceInterface<string> {

  constructor(
    readonly zohoApiService: ZohoApiService,
    readonly baseApiService: BaseApiService,
  ) {
    super(baseApiService);
  }

  getExportType(): ExportTypeEnum {
    return ExportTypeEnum.ZOHO;
  }

  authenticate(code: string, accounts_server: string): Observable<any> {
    return this.zohoApiService.authenticate(code, accounts_server);
  }

  logout(): Observable<any> {
    return this.zohoApiService.logout();
  }

  getSettings(): Observable<any> {
    return this.zohoApiService.getSettings();
  }

  getMappingFields(params: MappingFieldsRequestParamDto = {}): Observable<any> {
    return this.zohoApiService.getMappingFields(params);
  }

  setSettings(settings: any): Observable<any> {
    return this.zohoApiService.updateSettings(settings);
  }
}
